module.exports = __webpack_public_path__ + "img/paint-strip-red-down.4334e05.png";